// Função para traduzir posições de jogadores
export const translatePosition = (position: string | undefined): string => {
    if (!position) return "Desconhecido";
  
    const positionMap: Record<string, string> = {
      // Posições gerais
      "Defenders": "Defensores",
      "Forwards": "Atacantes",
      "Midfielders": "Meio-Campistas",
      "Goalkeepers": "Goleiros",
      
      // Posições específicas
      "ST": "AT",
      "CF": "CA",
      "LW": "PE",
      "RW": "PD",
      "CAM": "MEI",
      "CM": "MC",
      "CDM": "VOL",
      "LM": "ME",
      "RM": "MD",
      "CB": "ZAG",
      "LB": "LE",
      "RB": "LD",
      "GK": "GOL",
      "LWB": "ALE",
      "RWB": "ALD",
    };
  
    // Verifique se a posição está no mapa
    if (position in positionMap) {
      return positionMap[position];
    }
    
    // Se for uma string multilinha ou com espaços, tente encontrar correspondências parciais
    for (const [key, value] of Object.entries(positionMap)) {
      if (position.includes(key)) {
        return value;
      }
    }
    
    // Retorne a posição original se não houver tradução
    return position;
  };